/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHourGlassMiddle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 2a1 1 0 0 1 .481.123c.177.097.393.256.609.491.109.12.207.25.293.393.85 1.417.81 3.198-.048 4.654l-.084.142-.83 1.417-.43.757C16.388 11.069 16 11.889 16 12c0 .124.484 1.134 1.214 2.419l.318.554.803 1.367c.859 1.455.898 3.236.048 4.653a2.45 2.45 0 0 1-.293.393 2.419 2.419 0 0 1-.609.49A1 1 0 0 1 17 22H7a1 1 0 0 1-.481-.123 2.419 2.419 0 0 1-.609-.491 2.45 2.45 0 0 1-.293-.393c-.85-1.417-.81-3.198.048-4.654l.084-.142.83-1.417.43-.757C7.612 12.931 8 12.111 8 12c0-.124-.484-1.134-1.214-2.419l-.318-.554-.803-1.367c-.859-1.455-.898-3.236-.048-4.653a2.45 2.45 0 0 1 .293-.393c.216-.235.432-.394.609-.49A1 1 0 0 1 7 2zm-.357 2H7.356l-.023.035c-.432.72-.442 1.637-.039 2.439l.093.17.925 1.577.512.904C9.622 10.561 10 11.413 10 12c0 .656-.472 1.642-1.475 3.407l-.213.372-.925 1.577c-.495.84-.517 1.838-.054 2.609l.024.035h9.286l.024-.035c.463-.771.441-1.77-.054-2.608l-.925-1.578-.512-.904C14.378 13.439 14 12.587 14 12c0-.656.472-1.642 1.475-3.407l.213-.372.925-1.577c.495-.84.517-1.838.054-2.609zM15 17v2h-2v-2zm-4 0v2H9v-2zm2-9v2h-2V8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHourGlassMiddle as HourGlassMiddle };
